import StockListado from '../../../models/stock/stock_listado'
import { TABLA_CAMBIO_CEREAL_VALIDO, TABLA_EXISTENCIA_DIARIA, TABLA_EXISTENCIA_DIARIA_VARIEDAD, TABLA_STOCK_EXPORTADOR } from '../../../config/tables'
import { COL_CEREAL_VALIDO, COL_EXISTENCIA_DIARIA, COL_EXISTENCIA_DIARIA_VARIEDAD, COL_STOCK_EXPORTADOR } from './listados/constantes'
import { toast } from 'react-toastify'
import moment from 'moment'
import Stock from '../../../models/stock/stock'
import { obtenerPesoPromedioCamion, updateParametroInteger } from '../../Camiones/actions'
import { obtenerCumplimientoCupos } from '../../Cupos/actions'
import { getFormValues } from 'redux-form'
import { FORM_VENTA_A_EXPORTADOR } from '../../../config/forms'
import MovimientosTerminal from '../../../models/stock/movimientos_terminal'
import { obtenerVentasAExportadorActual } from './listados'

const stockListado = new StockListado()
const movimientosTerminal = new MovimientosTerminal()

export default function obtenerMercaderiaEnTerminal () {
  return (dispatch) => {
    stockListado.getMercaderiaEnTerminalTotal()
      .then((data) => {
        dispatch({ type: 'EXISTENCIA_DIARIA', data })
      })
      .catch((error) => {
        console.log(error)
      })
  }
}

export function obtenerExistenciaDiariaPorVariedad (fechaConsulta) {
  return (dispatch) => {
    dispatch({
      type: 'UPDATE_MUITABLE',
      newState: {
        isLoading: true
      },
      id: TABLA_EXISTENCIA_DIARIA_VARIEDAD
    })

    const fecha = moment(fechaConsulta).format('YYYY-MM-DD')
    stockListado.getExistenciaDiariaVariedad(fecha)
      .then((data) => {
        const customToolbar = null
        dispatch({
          type: 'UPDATE_MUITABLE',
          newState: {
            columns: COL_EXISTENCIA_DIARIA_VARIEDAD,
            data: data,
            title: `Existencia diaria por variedad`,
            isLoading: false,
            fixed2Decimales: false,
            extraOptions: {
              customToolbar,
              print: false,
              pagination: false,
              tableBodyMaxHeight: '499px'
            }
          },
          id: TABLA_EXISTENCIA_DIARIA_VARIEDAD
        })
      })
      .catch((error) => {
        console.log(error)
        toast.error('Error al intentar obtener los datos')
      })
  }
}

export function obtenerExistenciaDiariaPorCereal (fechaConsulta) {
  return (dispatch) => {
    dispatch({
      type: 'UPDATE_MUITABLE',
      newState: {
        isLoading: true
      },
      id: TABLA_EXISTENCIA_DIARIA
    })

    const fecha = moment(fechaConsulta).format('YYYY-MM-DD')
    stockListado.getExistenciaDiariaPorCereal(fecha)
      .then((data) => {
        const customToolbar = null
        dispatch({
          type: 'UPDATE_MUITABLE',
          newState: {
            columns: COL_EXISTENCIA_DIARIA,
            data: data,
            title: `Existencia diaria`,
            isLoading: false,
            fixed2Decimales: false,
            extraOptions: {
              customToolbar,
              print: false,
              pagination: false,
              tableBodyMaxHeight: '499px'
            }
          },
          id: TABLA_EXISTENCIA_DIARIA
        })
      })
      .catch((error) => {
        console.log(error)
        toast.error('Error al intentar obtener los datos')
      })
  }
}

export function obtenerCambioCerealValido () {
  return (dispatch) => {
    dispatch({
      type: 'UPDATE_MUITABLE',
      newState: {
        isLoading: true
      },
      id: TABLA_CAMBIO_CEREAL_VALIDO
    })

    stockListado.getCambioCerealValido()
      .then((data) => {
        const customToolbar = null
        dispatch({
          type: 'UPDATE_MUITABLE',
          newState: {
            columns: COL_CEREAL_VALIDO,
            data: data,
            title: 'Cambios de cereal validos',
            isLoading: false,
            fixed2Decimales: false,
            extraOptions: {
              customToolbar,
              print: false,
              pagination: false,
              tableBodyMaxHeight: '499px'
            }
          },
          id: TABLA_CAMBIO_CEREAL_VALIDO
        })
      })
      .catch((error) => {
        console.log(error)
        toast.error('Error al intentar obtener los datos')
      })
  }
}

export function obtenerComposicionStockExportadores () {
  return (dispatch) => {
    dispatch({
      type: 'UPDATE_MUITABLE',
      newState: {
        isLoading: true
      },
      id: TABLA_STOCK_EXPORTADOR
    })

    stockListado.getUltimoStockExportadores()
      .then((data) => {
        const customToolbar = null
        dispatch({
          type: 'UPDATE_MUITABLE',
          newState: {
            columns: COL_STOCK_EXPORTADOR,
            data: data,
            title: `Composición stock exportadores`,
            isLoading: false,
            fixed2Decimales: false,
            extraOptions: {
              customToolbar,
              print: false,
              pagination: false,
              tableBodyMaxHeight: '499px'
            }
          },
          id: TABLA_STOCK_EXPORTADOR
        })
      })
      .catch((error) => {
        console.log(error)
        toast.error('Error al intentar obtener los datos')
      })
  }
}

export function actualizarDetalles (detalle) {
  return (dispatch) => {
    dispatch({
      type: 'ACTUALIZAR_DETALLES',
      detalle: detalle
    })
  }
}

export function obtenerTotalStock () {
  return (dispatch) => {
    return Stock.getStockTotal()
      .then((data) => {
        console.log(data, 'data')
        dispatch({ type: 'RECEIVE_STOCK_TOTAL', data })
      })
      .catch((error) => {
        console.log(error)
      })
  }
}

export function obtenerParametroCamion () {
  return obtenerPesoPromedioCamion()
}

export function obtenerParametroCumplimiento () {
  return obtenerCumplimientoCupos()
}

export function updateParametroCamion (value) {
  return updateParametroInteger('NETORGDF', value)
}

export function updateParametroCumplimiento (value) {
  return (dispatch) => {
    dispatch(updateParametroInteger('CUMPLICU', value))
    dispatch({ type: 'RECEIVE_PROMEDIO_CUMPLIMIENTO', value })
  }
}

export function updateSimulacionExportador (newValue) {
  return (dispatch) => {
    dispatch({ type: 'UPDATE_SIMULACION_POR_EXPORTADOR', newValue })
  }
}

export function venderAExportador () {
  return (dispatch, getState) => {
    const state = getState()
    const formValues = getFormValues(FORM_VENTA_A_EXPORTADOR)(state)
    if (formValues) {
      movimientosTerminal.addVentaExportador(formValues)
        .then((result) => {
          if (!result.error) {
            toast.success('Venta realizada exitosamente')
            dispatch(obtenerVentasAExportadorActual())
          } else {
            const descripcionBackend = result.error.descripcion
            const regex = /ERROR:\s+_[A-Z]+_\s+(.*?)\n/
            const coincidencia = descripcionBackend.match(regex)
            if (coincidencia && coincidencia[1]) {
              toast.error(coincidencia[1])
            } else {
              toast.error('Error al intentar crear la venta a exportador')
            }
          }
        })
        .catch((error) => {
          console.log(error)
          toast.error('Error al intentar crear la venta a exportador')
        })
    }
  }
}

export function actualizarVentaAExportador () {
  return (dispatch, getState) => {
    const state = getState()
    const formValues = getFormValues(FORM_VENTA_A_EXPORTADOR)(state)
    const id = formValues.id
    movimientosTerminal.updateVentaExportador(formValues, id)
      .then((result) => {
        if (!result.error) {
          toast.success('La venta fue modificada correctamente')
          dispatch(obtenerVentasAExportadorActual())
        } else {
          toast.error('Error al intentar actualizar la venta')
        }
      })
      .catch((error) => {
        console.log(error)
        toast.error('Error al intentar actualizar la venta')
      })
  }
}

export function eliminarVentaExportador (id) {
  return (dispatch) => {
    movimientosTerminal.deleteVentaExportador(id)
      .then((result) => {
        if (!result.error) {
          dispatch(obtenerVentasAExportadorActual())
        } else {
          toast.error('Error al intentar eliminar la venta')
        }
      })
      .catch((error) => {
        console.log(error)
        toast.error('Error al intentar eliminar la venta')
      })
  }
}

export function crearCambioCereal (cerealO, cerealD) {
  return (dispatch) => {

  }
}
